export default function setStyle(el, ruleName, val) {
  el.style[ruleName] = val;
}
